export class HasDynamicValues {
  constructor(modelName, prefix) {
    this.className = modelName;
    this.prefix = prefix;
  }
}

export default function hasDynamicValues(type, prefix) {
  return function (target, key) {
    if (!target.constructor.dynamicRelationships) {
      target.constructor.dynamicRelationships = [];
    }

    target.constructor.dynamicRelationships.push({
      modelName: new HasDynamicValues(type, prefix),
      propertyName: key,
    });
  };
}
